import Accordion from './Accordion'
export default Accordion



// WEBPACK FOOTER //
// ./src/molecules/Accordion/index.js